import { axios } from '@/services/axios';

const getTCAPUserByID = async (id) => {
    const res = await axios.get(`/TCAPUser/${id}`);
    return res.data;
};

export default getTCAPUserByID;
